import type { ParsedAttributeQuery } from '../types'

export function matchesAttributeHaystack(
  haystack: string,
  parsed: ParsedAttributeQuery,
): boolean {
  for (const phrase of parsed.phrases) {
    if (!haystack.includes(phrase)) return false
  }
  for (const term of parsed.mustInclude) {
    if (!haystack.includes(term)) return false
  }
  for (const term of parsed.mustExclude) {
    if (haystack.includes(term)) return false
  }
  return true
}
